/* eslint-disable */
var resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;

module.exports = {
  // from processing.js
  map: function map(value, istart, istop, ostart, ostop) {
    return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
  },
  nearest: function nearest(value, step) {
    return Math.round(value / step) * step;
  },
  roundToStep: function(value, step, backward) {
    if (value % step === 0) return value;
    if (!backward) return value + (step - (value % step));
    return value - (value % step);
  },
  priceRound: function(value) {
    return Math.round(value * 100) / 100;
  },
  /**
   * @param {number} value
   * @param {number} decimalsLength length of decimal
   * @param {number} sectionsLength length of whole part
   * @param {String} sectionDelimiter sections delimiter
   * @param {String} decimalDelimiter decimal delimiter
   * @return {String}
   */
  numberFormat: function(value, decimalsLength, sectionsLength, sectionDelimiter, decimalDelimiter) {
    var re = '\\d(?=(\\d{' + (sectionsLength || 3) + '})+' + (decimalsLength > 0 ? '\\D' : '$') + ')';
    var num = value.toFixed(Math.max(0, ~~decimalsLength));

    return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(re, 'g'), '$&' + (sectionDelimiter || ','));
  },
  /**
   *
   * @param {number} value
   * @return {String}
   */
  priceFormat: function(value) {
    if (value < 0) {
      return '-' + resolveByCountry("\u00A3", "\u20AC") + this.numberFormat(-(value),2,3,',','.');
    }
    else {
      return resolveByCountry("\u00A3", "\u20AC") + this.numberFormat(value,2,3,',','.');
    }
  }
};
